export const formatCurrency = (amount: number | string, currencyCode?: string, locale?: string, decimalPlaces?: number): string => {
	const resolvedLocale = locale || 'en-US';
	let currencyAbreviation = currencyCode || 'USD';

	if (currencyAbreviation === 'USD' && resolvedLocale === 'en-AU') {
		currencyAbreviation = 'AUD';
	}

	const formattedAmount = new Intl.NumberFormat(resolvedLocale, {
		style: 'currency',
		currency: currencyAbreviation,
		currencyDisplay: 'narrowSymbol',
		...(decimalPlaces !== undefined
			? {
					minimumFractionDigits: decimalPlaces,
					maximumFractionDigits: decimalPlaces
				}
			: {})
	}).format(Number(amount));

	return `${currencyAbreviation.toUpperCase()} ${formattedAmount}`;
};
